import { CustomButton } from '@medtronic/pecc-react-component-library-js';
import { Box } from '@mui/material';
import { ShareKnowledgeIcon } from '~/icons';
import { feedbackButtonStyles, feedbackButtonsBlockStyles } from './styles';

const logAnIncidentEmailTo = 'rs.healthcareitsupport-global@medtronic.com';
const logAnIncidentEmailSubject = 'Healthcare Data Platform Support';
const logAnIncidentEmailBody = `Description of Issue:

Name:

UserID:

Email:

Environment (STAGE or PROD):

Error Message (if applicable):

Please provide screen shots of the error messages(s) or issues(s):`;

const logAnIncidentFeedbackLink = `https://outlook.office.com/mail/deeplink/compose?to=${encodeURIComponent(logAnIncidentEmailTo)}&subject=${encodeURIComponent(logAnIncidentEmailSubject)}&body=${encodeURIComponent(logAnIncidentEmailBody)}`;

const enhancementRequestEmailTo = 'rs.digitalhealth-healthcaredata@medtronic.com';
const enhancementRequestEmailSubject = 'HDP Enhancement Request';
const enhancementRequestEmailBody = `Enhancement Title:
  [Short, clear name for the enhancement]

Current Behavior / Limitation:
  [Briefly describe what happens today and why it’s a challenge or limitation]

Proposed Enhancement:
  [Describe the enhancement you are requesting and how it would work from a user perspective]

Business Value / Impact:
  [Explain the benefit—time savings, risk reduction, improved accuracy, better insights, etc.]

Who Would Benefit:
  [e.g., specific teams, roles, or a broad user group]

Frequency of Use:
  [e.g., daily, weekly, monthly, ad hoc]

Priority / Urgency:
  [Low / Medium / High, with a short explanation if helpful]

Attachments or Examples (if applicable):
  [Screenshots, sample reports, mockups, or reference materials]

Name:

Role/Team:

Contact Info:`;

const enhancementRequestFeedbackLink = `https://outlook.office.com/mail/deeplink/compose?to=${encodeURIComponent(enhancementRequestEmailTo)}&subject=${encodeURIComponent(enhancementRequestEmailSubject)}&body=${encodeURIComponent(enhancementRequestEmailBody)}`;

const FeedbackButtonsBlock = () => (
  <Box sx={feedbackButtonsBlockStyles}>
    <CustomButton
      buttonType="outlined"
      onClick={() => window.open(logAnIncidentFeedbackLink, '_blank', 'noopener,noreferrer')}
    >
      <Box sx={feedbackButtonStyles}>
        <ShareKnowledgeIcon />
        Log an Incident
      </Box>
    </CustomButton>
    <CustomButton
      buttonType="outlined"
      onClick={() => window.open(enhancementRequestFeedbackLink, '_blank', 'noopener,noreferrer')}
    >
      <Box sx={feedbackButtonStyles}>
        <ShareKnowledgeIcon />
        Enhancement Request
      </Box>
    </CustomButton>
  </Box>
);

export default FeedbackButtonsBlock;
